import React from 'react';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { DownloadSectionItem } from './DownloadSectionItem';
import { DownloadSectionStyled } from './styled';
export function DownloadSectionComponent(props) {
    const { files, title, isRightToLeft, isTargetBlank } = props;
    if (files?.length > 0) {
        return (React.createElement(DownloadSectionStyled, null,
            React.createElement(RegularTextLevel3, { weight: 500 }, title),
            files.map((file) => (React.createElement(DownloadSectionItem, { key: file.name, filePath: file.filePath, type: file.type, name: file.name, size: file.size, isRightToLeft: isRightToLeft, isTargetBlank: isTargetBlank })))));
    }
    return null;
}
